<script>
const serverSrc = "http://localhost:8080/api";
const token = "12345678";
const hasEnter = false;
const userSite = "中国钓鱼岛";
export default {
  userSite, //用户地址
  token, //用户token身份
  serverSrc, //服务器地址
  hasEnter, //用户登录状态
};
</script>


// WEBPACK FOOTER //
// src/components/Global.vue